import tw, { styled } from 'twin.macro';

import Flex from '../Layout/Flex';

const Profile = styled(Flex)`
  ${tw`h-12`}
`;

export default Profile;
